import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const ContainerStyles = css``
export const ImageContainerStyles = css``
export const DescriptionContainerStyles = css``
export const TitleSectionStyles = css``
export const MediaOptionsStyles = css``
export const OptionIconStyles = css``
export const VideoPlayStyles = css``
export const MediaStyles = css`
  border-color: ${colors.blue};
`
export const DescriptionStyles = css``
